import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagVerOrdenesCerradasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagVerOrdenesCerradas'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagVerOrdenesCerradas'
          label='Ordenes cerradas'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagVerOrdenesCerradasFormGroup)
